import { GridColDef } from "@mui/x-data-grid";
import { CustomRadioGroupInput } from "../components/custom_radio_group_input";

/**
 * Props
 */

type Props = {
  onActionInspecao1Change: (idInspecaoMaquinaEquipItem: number, value: string | number | null) => void;
  onActionInspecao2Change: (idInspecaoMaquinaEquipItem: number, value: string | number | null) => void;
};

export const GenerateItensInspecaoColumnDefs = ({
  onActionInspecao1Change,
  onActionInspecao2Change,
}: Props): GridColDef[] => {
  const inspecao1Options = [
    {
      id: "N",
      label: "NA",
      style: {
        backgroundColor: "#89c4f4",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "A",
      label: "A",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "C",
      label: "C",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "P",
      label: "P",
      style: {
        backgroundColor: "#f8cb00",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  const inspecao2Options = [
    {
      id: "A",
      label: "A",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Item",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => <div className="w-full h-full py-2 flex items-center">{value}</div>,
    },
    {
      field: "inspecao1",
      filterable: false,
      headerName: "1ª Inspeção",
      minWidth: 280,
      sortable: false,
      valueGetter: (_, row) => ({ idInspecaoMaquinaEquipItens: row["idInspecaoMaquinaEquipItens"], inspecao1: row["inspecao1"] }),
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center">
            <CustomRadioGroupInput
              name="inspecao1"
              options={inspecao1Options}
              value={value.inspecao1}
              onValueChange={v => onActionInspecao1Change(value.idInspecaoMaquinaEquipItens, v)}
            />
          </div>
        );
      },
    },
    {
      field: "inspecao2",
      filterable: false,
      headerName: "2ª Inspeção",
      minWidth: 155,
      sortable: false,
      valueGetter: (_, row) => ({
        idInspecaoMaquinaEquipItens: row["idInspecaoMaquinaEquipItens"],
        inspecao1: row["inspecao1"],
        inspecao2: row["inspecao2"],
      }),
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center">
            <CustomRadioGroupInput
              name="inspecao2"
              options={inspecao2Options}
              disabled={value.inspecao1 !== "C" && value.inspecao1 !== "P"}
              value={value.inspecao2}
              onValueChange={v => onActionInspecao2Change(value.idInspecaoMaquinaEquipItens, v)}
            />
          </div>
        );
      },
    },
  ];
}
